import EcommerceImpressionWrapper from './EcommerceImpressionWrapper';

export default EcommerceImpressionWrapper;
